import { render } from "./BasicUsage.vue?vue&type=template&id=59758731"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"
script.render = render

export default script